// GENERATED from backend/shared/transactionTypes.js by generateVocabularyMirror.js — never edit by hand

export const VOCAB = {
  "NEW_TICKET": {
    "write": "Ny Billett",
    "match": [
      "Ny Billett",
      "Ny Billett - CH",
      "Ny Billett - EBS",
      "Ny Billett - WG",
      "Ny Billett - OK D."
    ]
  },
  "NEW_TICKET_CANCEL": {
    "write": "Avbryt Ny Billett",
    "match": [
      "Avbryt Ny Billett",
      "Avbryt Ny Billet"
    ]
  },
  "TOPUP": {
    "write": "Fylle på",
    "match": [
      "Fylle på"
    ]
  },
  "TOPUP_CANCEL": {
    "write": "Avbryt Fylle på",
    "match": [
      "Avbryt Fylle på"
    ]
  },
  "PAYOUT": {
    "write": "Utbetaling",
    "match": [
      "Utbetaling",
      "Utbetaling - OK D."
    ]
  },
  "PAYOUT_CANCEL": {
    "write": "Avbryt Utbetaling",
    "match": [
      "Avbryt Utbetaling"
    ]
  },
  "PAYOUT_TERMINAL": {
    "write": "Utbetaling fra terminal",
    "match": [
      "Utbetaling fra terminal"
    ]
  },
  "PAYOUT_TERMINAL_CANCEL": {
    "write": "Avbryt Utbetaling fra terminal",
    "match": [
      "Avbryt Utbetaling fra terminal"
    ]
  },
  "PAYOUT_SHIFT_CLOSE": {
    "write": "Utbetaling - Avslitte skiftet",
    "match": [
      "Utbetaling - Avslitte skiftet"
    ]
  },
  "NEW_PAPIR": {
    "write": "Ny Papir Billett",
    "match": [
      "Ny Papir Billett",
      "Ny Papir Billet",
      "Ny Papir"
    ]
  },
  "NEW_PAPIR_CANCEL": {
    "write": "Avbryt Ny Papir Billett",
    "match": [
      "Avbryt Ny Papir Billett",
      "Avbryt Ny Papir Billet",
      "Avbryt Ny Papir"
    ]
  },
  "NEW_PAPIR_KINGO": {
    "write": "Ny Papir Kingo Billett",
    "match": [
      "Ny Papir Kingo Billett",
      "Ny Papir Kingo Billet"
    ]
  },
  "NEW_PAPIR_XTIPP": {
    "write": "Ny Papir Xtipp Billett",
    "match": [
      "Ny Papir Xtipp Billett",
      "Ny Papir Xtipp Billet"
    ]
  },
  "PAYOUT_PAPIR": {
    "write": "Utbetaling Papir Billett",
    "match": [
      "Utbetaling Papir Billett",
      "Utbetalling Papir Billett",
      "Utbetaling Papir"
    ]
  },
  "PAYOUT_PAPIR_KINGO": {
    "write": "Utbetaling Papir Kingo Billett",
    "match": [
      "Utbetaling Papir Kingo Billett"
    ]
  },
  "PAYOUT_PAPIR_XTIPP": {
    "write": "Utbetaling Papir Xtipp Billett",
    "match": [
      "Utbetaling Papir Xtipp Billett"
    ]
  },
  "DEPOSIT": {
    "write": "Sett inn",
    "match": [
      "Sett inn",
      "Inn"
    ]
  },
  "DEPOSIT_CANCEL": {
    "write": "Avbryt Sett inn",
    "match": [
      "Avbryt Sett inn",
      "Avbryt Inn"
    ]
  },
  "WITHDRAW": {
    "write": "Ta ut",
    "match": [
      "Ta ut",
      "Ut"
    ]
  },
  "WITHDRAW_CANCEL": {
    "write": "Avbryt Ta ut",
    "match": [
      "Avbryt Ta ut",
      "Avbryt Ut"
    ]
  },
  "PAY_CASH": {
    "write": "Betal med Cash",
    "match": [
      "Betal med Cash"
    ]
  },
  "PAY_CASH_REVERSAL": {
    "write": "Tilbake Betal med Cash",
    "match": [
      "Tilbake Betal med Cash"
    ]
  },
  "PAY_CARD": {
    "write": "Betal med kort",
    "match": [
      "Betal med kort",
      "Enkel betal med kort"
    ]
  },
  "PAY_ACCOUNT": {
    "write": "Betal med spillerkonto",
    "match": [
      "Betal med spillerkonto"
    ]
  },
  "CASH_WITHDRAWAL": {
    "write": "Kontant uttak",
    "match": [
      "Kontant uttak"
    ]
  },
  "CASH_WITHDRAWAL_CANCEL": {
    "write": "Avbryt Kontant uttak",
    "match": [
      "Avbryt Kontant uttak"
    ]
  },
  "REFUND": {
    "write": "Refusjon",
    "match": [
      "Refusjon",
      "Refusjon%"
    ]
  },
  "CASH_IN": {
    "write": "Innskudd kasse",
    "match": [
      "Innskudd kasse"
    ]
  },
  "CASH_OUT": {
    "write": "Uttak kasse",
    "match": [
      "Uttak kasse"
    ]
  },
  "CASHOUT_WALLET_TERMINAL": {
    "write": "cashout - cash_from_wallet - terminal",
    "match": [
      "cashout - cash_from_wallet - terminal"
    ],
    "reconciled": false
  }
};

export const PATTERNS = {
  "ANY_CANCEL": "Avbryt%",
  "ANY_CANCEL_PREFIXED": "Avbryt %",
  "ANY_PAYOUT": "Utbetaling%",
  "ANY_REFUND": "Refusjon%"
};

// transactions.provider: the suppliers a refund can be booked against
export const REFUND_PROVIDERS = ["CH","WG","OK D."];

// The value new code must write for a concept
export function write(key) {
  const entry = VOCAB[key];
  if (!entry) {
    throw new Error(`Unknown transaction type: ${key}`);
  }
  return entry.write;
}

// Cancellations are the base value behind an "Avbryt " prefix
export const CANCEL_PREFIX = 'Avbryt ';
